import React from "react"
import { Container } from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import DataTables from "./DataTables"
import MetaTag from "components/Common/Meta-tag"

function Reviews() {
  return (
    <>
      <MetaTag title={"All Reviews"} />

      <div className="page-content">
        <Breadcrumbs title="Dashboard" breadcrumbItem="All Reviews" />
        <Container fluid>
          <div className="container-fluid">
            <DataTables />
          </div>
        </Container>
      </div>
    </>
  )
}

export default Reviews
